import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import queryString from 'query-string';
const RazorpayAPIKey ="rzp_live_gqN0HLYx3a5HsE";
const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'Select', value: '' },
    { key: 'SUCCESS', value: 'SUCCESS' },
    { key: 'FAILED', value: 'FAILED' },
]
const typeArray =[
    { key: 'Select', value: '' },
    { key: 'Debit', value: 'DirDebit' },
    { key: 'Credit', value: 'Credit' },
    { key: 'GiftCard', value: 'Debit' },
]

const providerArray =[
    { key: 'Select', value: '' },
    { key: 'Manual', value: 'Manual' },
    { key: 'QwikCilverNonAmazon', value: 'QwikCilverNonAmazon' },
    { key: 'QwikCilver', value: 'QwikCilver' },
    { key: 'RazorPay', value: 'RazorPay' },
    { key: 'CashFree', value: 'CashFree' },
]

const searchBy = [
    { key: 'Select', value: '' },
    { key: 'Amount', value: 'amount' },
    { key: 'Source', value: 'Provider' },
    { key: 'Type', value: 'type' },
    { key: 'Transaction Date', value: 'Date' },
    { key: 'Transaction ID', value: 'orderId' },
    { key: 'Status', value: 'status' }
];

function getColumns() {
    let columns = [
        {
            title: 'Amount',
            field: 'amount',
            render: (item) => (
            <div>
            {item.type =='Credit' &&<span style={{color:"green"}}>+₹</span>}
            {item.type =='Debit' &&<span style={{color:"red"}}>-₹</span>}
            {parseFloat(item.amount).toFixed(2)}</div>),
            width: "10%"
            
        },
        //{ title: 'Transaction Type', field: 'type' },
        { title: 'Source', field: 'Provider', render: (item) => (
            <div>
            {item['Source'].indexOf("Link")==0 ? (
            <span style={{color:"blue"}}>
                <NavLink exact to={{pathname: ROUTES.PaymentLinks, linkId: item['linkId']}}>
                {item['Source']} 
                    </NavLink>
                </span>
            ):(<span>{item['Source']}</span>)}
             ({item['Provider']?item['Provider']:'CashFree'})
            </div>),
        },
        { title: 'Payment Date', field: 'Date' ,render: (item) => getFormattedDateTime(item.Date)},
        { title: 'Transaction ID', field: 'orderId' },
        { title: 'Description', field: 'Description' },
        { title: 'Status', field: 'status' },
        {
            title: 'Closing Balance',
            field: 'closingBalance',
            render: (item) => (
                <div>
                {item.closingBalance &&<span>₹
                {parseFloat(item.closingBalance).toFixed(2)}</span>}
                </div>),
            
            
        }
    ];

    return columns;
}
function getSource(item) {
    if(item['Source'].indexOf("Link")){
    return '<a>'+ item['Source']+'</a>';
    }else{
    return item['Source'];
    }
    
}


function getEarning(item) {
    if(item['type'] == 'Credit'){
    return '<span>+</span> ₹' + parseFloat(item['amount']).toFixed(2)+'';
    }else if(item['type'] == 'Debit'){
    return '<span>-</span> ₹' + parseFloat(item['amount']).toFixed(2);
    }else{
    return '₹' + parseFloat(item['amount']).toFixed(2);
    }
    
}
function getLinksColumns() {
    let columns = [
        {
            title: 'Link Amount (₹)',
            field: 'linkAmount',
            render: (item) => getLinkAmount(item['linkAmount'])
        },
        {
            title: 'Paid Amount (₹)',
            field: 'amount',
            render: (item) => getLinkAmount(item['amount'])
        },
        { title: 'Link URL', field: 'linkURL' },
        { title: 'Last Paid', field: 'Updated' },
        { title: 'Created', field: 'Date' }
    ];
    return columns;
}

function getLinkAmount(itemAmount) {
    return '₹' + parseFloat(itemAmount).toFixed(2);
}

// const options = ['Option 1', 'Option 2'];

class ProfileWalletTransaction extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        isLastPage:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'amount',
        loading: false,

        alert: 0,
        alertMessage: '',
        storeTag: '',
        backArrow: false,
        flag: 0,
        data: [],
        dataLinks: [],
        options: [],
        currentTotalBalance: 0,
        withdrawAbaleAmount: 0,
        SelectedAccountNumber: '',
        withdrawAmount: '',
        addAmount: '',
        provider:'RazorPay',
        orderNote: '',
        remarks: '',
        Beneficiary: [],
        benfList: [],
        transactionCharges: 2.5,
        ShowFlashMessage: false,
        FlashMessage: ''
    };

    dataArray = [];

    
    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
        
    }

    componentWillUnmount() {
        this._isMounted = false;
    }



    async relaodData() {
        
        if (this._isMounted) {
            this.setState({
                loading: true
            });
        }

        let bodyData = {
            ProfileUniqeID: this.props.UniqeID,
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        
        await RestServices.getAllCashFreeTransaction(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                if(responseData.list.length>0){
                   
                   
                    
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            alert: 0,
                            loading: false
                        });
                    }
                    
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            data: [], 
                            isLastPage: true,
                            alert: 0,
                            loading: false
                        });
                    }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        loading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
         if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    

    async loadData() {
        this.setState({ flag: 1 });
        await this.relaodData();
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    }

    copyToClipboard = (rowData, FlashMessageString) => {
        
        var textField = document.createElement('textarea');
        textField.innerText = rowData.linkURL;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        if (this._isMounted) {
            this.setState({
                ShowFlashMessage: true,
                FlashMessage: FlashMessageString
            });
            setTimeout(() => {
                this.setState({ ShowFlashMessage: false, FlashMessage: '' });
            }, 5000);
        }
    };
    onChangeValues = (event) => {
        this.setState({ search_key: '' }); 
        if(event.target.type === 'number' ){
            if (Number.isNaN(Number.parseFloat(event.target.value))) {
            }else{
             this.setState({ [event.target.name]: parseFloat(event.target.value) });
            }
        }else{
            if (event.target.value === '')
                this.setState({ [event.target.name]: '' });
            else {
                this.setState({ [event.target.name]: event.target.value });
            }
            
        }
        };
    render() {
        

        return (
            <div>
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}

                {this.state.flag === 1 && <Spinner animation="border" />}
                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 2 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 5 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                

                
                

                {this.state.flag === 2 && (
                    <div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>

                                    {this.state.search_by =='status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by =='type' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {typeArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by =='Provider' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {providerArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by =='Date' &&<Form.Control
                                        placeholder="Select Date"
                                        type="date"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        
                                    />}

                                    {this.state.search_by !='type' && this.state.search_by !='Provider' && this.state.search_by !=='status' && this.state.search_by !=='Date' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        <MaterialTable
                            title="Transactions"
                            columns={getColumns()}
                            data={this.state.data}
                            options={{
                                exportButton: {
                                    csv: true
                                },
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1,
                                
                            }}
                        />
                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
                {this.state.alert === 11 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ProfileWalletTransaction);
